import { useRef } from 'react'

const useMoveScroll = () => {
  const RefElement = useRef<any>(null)
  const RefInput = useRef<any>(null)
  const onMoveToElement = async () => {
    await RefElement.current?.scrollIntoView()
    
      RefInput.current.focus()
  }
  return { RefInput, RefElement, onMoveToElement }
}

export default useMoveScroll
